import { downloadText } from "@/lib/download-text";
import { importsWords as words } from "./imports-copy";

export interface FormatLine { column: string; readsWhen: string; note: string }

/** One shape a source file can take: its columns and a file to start from. */
export interface FormatShape { title: string; note: string; readsWhen: string; lines: FormatLine[]; template: { name: string; verb: string; text: () => string } }

/** What a source file holds, shape by shape and column by column, and each shape's template. */
export function SourceFormat({ shapes }: { shapes: FormatShape[] }) {
  return <details className="import-format">
    <summary>{words.fileFormat}</summary>
    <div className="grid gap-5 pt-2">
      {shapes.map((shape) => <section key={shape.title} className="grid gap-3" aria-label={shape.title}>
        <h4 className="font-medium">{shape.title}</h4>
        <div className="flex flex-wrap items-center gap-3">
          <button type="button" data-act="check" onClick={() => downloadText(shape.template.name, shape.template.text())}>{shape.template.verb}</button>
          <p className="text-meta text-muted-foreground">{shape.note}</p>
        </div>
        <table className="import-format-table">
          <thead><tr><th scope="col">{words.column}</th><th scope="col">{shape.readsWhen}</th><th scope="col"><span className="sr-only">Meaning</span></th></tr></thead>
          <tbody>{shape.lines.map((l) => <tr key={l.column}><th scope="row"><code>{l.column}</code></th><td>{l.readsWhen}</td><td>{l.note}</td></tr>)}</tbody>
        </table>
      </section>)}
    </div>
  </details>;
}
